(ns com.theplantscape.web-ui.tailwind.form.elements.select
  (:require [reagent.core :as r]))


(defn ui-select [title items]
  (let [hide (r/atom true)]
    (fn []
      [:div.relative.inline-block.text-left
       [:div
        [:div 
         [:button#menu-button.inline-flex.justify-center.w-full.rounded-md.border.border-gray-300.shadow-sm.px-4.py-2.bg-white.text-sm.font-medium.text-gray-700.hover:bg-gray-50.focus:outline-none.focus:ring-2.focus:ring-offset-2.focus:ring-offset-gray-100.focus:ring-indigo-500
          {:type "button" :aria-expanded "true" :aria-haspopup "true"
           :on-click #(swap! hide not)}
          title
          [:svg.-mr-1.ml-2.h-5.w-5 {:xmlns "http://www.w3.org/2000/svg" :view-box "0 0 20 20" :fill "currentColor" :aria-hidden "true"}
           [:path {:fill-rule "evenodd" :d "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" :clip-rule "evenodd"}]]]]]
       [:div.origin-top-right.absolute.right-0.mt-2.w-56.rounded-md.shadow-lg.bg-white.ring-1.ring-black.ring-opacity-5.focus:outline-none
        {:class (when @hide "hidden") :role "menu" :aria-orientation "vertical" :aria-labelledby "menu-button" :tabindex "-1"}
        (into [:div.py-1 {:role "none"}]
              (mapv (fn [{:keys [href text]}]
                      [:a#menu-item-0.text-gray-700.block.px-4.py-2.text-sm
                       {:href "#" :role "menuitem" :tabindex "-1"} text]) items))
        [:div.py-1 {:role "none"}]]])))


(defn ui-form-select [value-atom {:keys [name label placeholder tooltip options] :as attrib}]
  (let [focused (r/atom false)]
    (fn [value-atom {:keys [name label placeholder tooltip] :as attrib}]
      [:div {:data-tooltip-target (when tooltip (str "tooltip-" name))}
       (if @focused
         (when tooltip
           [:div#tooltip-default.inline-block.py-2.px-3.text-sm.font-medium.text-white.bg-gray-900.rounded-lg.shadow-sm.duration-300.tooltip.dark:bg-gray-700
            {:id (str "tooltip-" name) :role "tooltip"}
            [:div.tooltip-arrow tooltip]])
         [:label.font-semibold.text-sm.text-gray-600.pb-1 label])

       [:select.w-full.border.rounded-lg.px-3.py-2.mt-1.mb-2.mb-5-lg.ml-4-lg.text-sm
        {:class "w-2/3" :type "text" :name name :on-change (:store-fn attrib)
         :default-value @value-atom #_(current-value node-name @node-value)}
        (map (fn [[value text]]
               [:option {:value value :key value} text])
             options)]

       #_[:input.w-full.border.rounded-lg.px-3.py-2.mt-1.mb-2.mb-5-lg.ml-4-lg.text-sm
        {:type "text"
         :default-value @value-atom
         :value @value-atom
         :placeholder placeholder
         :name name
         :on-focus #(reset! focused true)
         :on-blur #(reset! focused false)
         :on-change (:store-fn attrib)}]])))

(defn ui-form-select-inline [value-atom {:keys [name label placeholder tooltip options] :as attrib}]
  (let [focused (r/atom false)]
    (fn [value-atom {:keys [name label placeholder tooltip] :as attrib}]
      [:div.flex.flex-row.items-center {:data-tooltip-target (when tooltip (str "tooltip-" name))}
       (if @focused
         (when tooltip
           [:div#tooltip-default.inline-block.py-2.px-3.text-sm.font-medium.text-white.bg-gray-900.rounded-lg.shadow-sm.duration-300.tooltip.dark:bg-gray-700
            {:id (str "tooltip-" name) :role "tooltip"}
            [:div.tooltip-arrow tooltip]])
         [:label.grow.font-semibold.text-sm.text-gray-600.pb-1 {:class "w/1-2"} label])
       [:select.border.rounded-lg.px-3.py-2.mt-1.mb-2.mb-5-lg.ml-4-lg.text-sm
        {:class "w-1/2" :type "text" :name name :on-change (:store-fn attrib)
         :default-value (get @value-atom name) #_(current-value node-name @node-value)}
        (map (fn [[value text]]
               [:option {:value value :key value :selected (when (= value (get value-atom name)) "selected")} text])
             options)]

       #_[:input.w-full.border.rounded-lg.px-3.py-2.mt-1.mb-2.mb-5-lg.ml-4-lg.text-sm
        {:type "text"
         :default-value @value-atom
         :value @value-atom
         :placeholder placeholder
         :name name
         :on-focus #(reset! focused true)
         :on-blur #(reset! focused false)
         :on-change (:store-fn attrib)}]])))


(defn ui-form-select-inline-fn [{:keys [get-value set-value name label placeholder tooltip options] :as attrib}]
  (let [focused (r/atom false)]
    (fn [{:keys [get-value set-value name label placeholder tooltip options] :as attrib}]
      [:div.flex.flex-row.items-center {:data-tooltip-target (when tooltip (str "tooltip-" name))}
       (if @focused
         (when tooltip
           [:div#tooltip-default.inline-block.py-2.px-3.text-sm.font-medium.text-white.bg-gray-900.rounded-lg.shadow-sm.duration-300.tooltip.dark:bg-gray-700
            {:id (str "tooltip-" name) :role "tooltip"}
            [:div.tooltip-arrow tooltip]])
         [:label.grow.font-semibold.text-sm.text-gray-600.pb-1 {:class "w/1-2"} label])
       [:select.border.rounded-lg.px-3.py-2.mt-1.mb-2.mb-5-lg.ml-4-lg.text-sm
        {:class "w-1/2" :type "text" :name name
         :on-change set-value
         :default-value (get-value name)  #_(current-value node-name @node-value)}
        (map (fn [[value text]]
               [:option {:value value
                         :key value}
                text])
             options)]])))
